import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "new_bookmark",
  "use": "new_bookmark-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"new_bookmark\"><path d=\"m12.215 6.29-1.258-4.14a1 1 0 0 0-1.914 0L7.785 6.29A1 1 0 0 1 6.83 7H3.123a1 1 0 0 0-.58 1.814l3.049 2.176a1 1 0 0 1 .374 1.11l-1.214 3.92a1 1 0 0 0 1.56 1.093l3.083-2.343a1 1 0 0 1 1.21 0l3.094 2.347a1 1 0 0 0 1.56-1.092L14.044 12.1a1 1 0 0 1 .373-1.11l3.046-2.176A1 1 0 0 0 16.88 7h-3.71a1 1 0 0 1-.956-.71Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol